import * as React from 'react';

const HourglassIconV2 = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width={14} height={14} viewBox="0 0 14 14" fill="none">
    <path
      d="M2.918 1.483h8.164M2.918 12.529h8.164"
      stroke="#0276FE"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="m7 9.163 1.44 1.44h1.681v-.48a3.12 3.12 0 1 0-6.243 0v.48H5.56z" fill="#fff" />
    <path d="M8.44 10.604 7 9.164l-1.441 1.44h-1.68v1.92h6.242v-1.92z" fill="#0276FE" />
    <path
      d="M8.44 10.604 7 9.164l-1.441 1.44h-1.68v1.92h6.242v-1.92z"
      stroke="#0276FE"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10.121 3.884V1.483H3.878v2.4c0 .697.234 1.374.664 1.921h4.914a3.1 3.1 0 0 0 .665-1.92"
      fill="#fff"
    />
    <path
      d="M10.121 3.884V1.483H3.878v2.4c0 .697.234 1.374.664 1.921h4.914a3.1 3.1 0 0 0 .665-1.92"
      stroke="#0276FE"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M4.542 5.805a3.115 3.115 0 0 0 4.915 0z" fill="#fff" />
    <path
      d="M4.542 5.805a3.115 3.115 0 0 0 4.915 0z"
      fill="#0276FE"
      stroke="#0276FE"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="m7 9.163 1.44 1.44h1.681v-.48a3.12 3.12 0 1 0-6.243 0v.48H5.56z"
      stroke="#0276FE"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export default HourglassIconV2;
